import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export class OnoButtonConfig {
  title: string;
  appearance?: 'primary' | 'secondary' | 'confirm' | 'accent' | 'warn' | 'danger';
  disabled?: boolean;
  description?: string;
  spinner?: boolean;
  maxWidth?: string;
  maxHeight?: string;
  minWidth?: string;
  minHeight?: string;
  inline?: boolean;
  translate?: boolean;

  constructor(
    title: string,
    appearance?: 'primary' | 'secondary' | 'confirm' | 'accent' | 'warn' | 'danger',
    disabled?: boolean,
    description?: string,
    spinner?: boolean,
    maxWidth?: string,
    maxHeight?: string,
    minWidth?: string,
    minHeight?: string,
    inline?: boolean,
    translate?: boolean
    ) {
      this.title = title;
      this.appearance = appearance || 'secondary';
      this.disabled = disabled || false;
      this.description = description || '';
      this.spinner = spinner || false;
      this.maxWidth = maxWidth || '';
      this.maxHeight = maxHeight || '';
      this.minWidth = minWidth || '';
      this.minHeight = minHeight || '';
      this.inline = inline || true;
      this.translate = translate || true;
    }

}

@Component({
  selector: 'app-ono-button',
  templateUrl: './ono-button.component.html',
  styleUrls: ['./ono-button.component.scss']
})
export class OnoButtonComponent implements OnInit {
  /**
   * OnoButtonComponent is used whenever a button is needed.
   * =================================
   * Accept different inputs:
   * - TITLE: is required and is the text displayed - it will be merged with translation service in future
   * - Appearance: common UI button colors : 'primary' | 'secondary' | 'confirm' | 'accent' | 'warn' | 'danger'
   * - Disabled: this is kinda self-explanatory
   * - Description: the title shown on button hover - accessibility
   * ==================================
   * Outputs: onoclick emits an empty event
   */

  @Input() title: string;
  @Input() appearance?: 'primary' | 'secondary' | 'confirm' | 'accent' | 'warn' | 'danger';
  @Input() disabled?: boolean;
  @Input() description?: string;
  @Input() spinner?: boolean;
  @Input() maxWidth?: string;
  @Input() maxHeight?: string;
  @Input() minWidth?: string;
  @Input() minHeight?: string;
  @Input() inline?: boolean;
  @Input() translate?: boolean;

  // @Input() config? : OnoButtonConfig; // NOT IMPLEMENTED YET

  @Output() onoclick = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if (!this.appearance) {this.appearance = 'secondary'; }
    if (!this.disabled) {this.disabled = false; }
    if (!this.description) {this.description = ''; }
    if (!this.spinner) {this.spinner = false; }
    if (!this.maxWidth) {this.maxWidth = ''; }
    if (!this.maxHeight) {this.maxHeight = ''; }
    if (!this.minWidth) {this.maxWidth = ''; }
    if (!this.minHeight) {this.maxHeight = ''; }
    if (!this.inline) {this.inline = false; }
    if (!this.translate) {this.translate = true; }
  }

  customClass() {
    return [
      this.disabled === true ? 'disabled' : '',
      this.appearance ? this.appearance : ''
    ];
  }

  customStyle() {
    return {
      'max-width': this.maxWidth,
      'max-height': this.maxHeight,
      'min-width': this.minWidth,
      'min-height': this.minHeight,
      display: this.inline === true ? 'inline-grid' : 'grid'
    };
  }

  getTitle() {
    return 'onoButtons.' + this.title.toLowerCase();
  }

}
